<template>
    <div>
        <h2 class="summary-heading">
            {{title}}
        </h2><br/>

        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__item">
                <control for="damagesReserve" label="Damages Reserve:" before-after="pound">
                    <input autocomplete="off" v-model.number="damagesReserve"
                           required
                           name="damagesReserve"
                           id="damagesReserve"
                           maxlength="100"
                           v-on:focus="damagesReserve = damagesReserve || ''"
                           v-on:blur="damagesReserve = damagesReserve || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="thirdPartyReserve" label="Third Party Costs Reserve:" before-after="pound">
                    <input autocomplete="off" v-model.number="thirdPartyReserve"
                           required
                           name="thirdPartyReserve"
                           id="thirdPartyReserve"
                           maxlength="100"
                           v-on:focus="thirdPartyReserve = thirdPartyReserve || ''"
                           v-on:blur="thirdPartyReserve = thirdPartyReserve || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="defenceCostsReserve" label="Defence Costs Reserve:" before-after="pound">
                    <input autocomplete="off" v-model.number="defenceCostsReserve"
                           required
                           name="defenceCostsReserve"
                           id="defenceCostsReserve"
                           maxlength="100"
                           v-on:focus="defenceCostsReserve = defenceCostsReserve || ''"
                           v-on:blur="defenceCostsReserve = defenceCostsReserve || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="paidDamages" label="Paid Damages:" before-after="pound">
                    <input autocomplete="off" v-model.number="paidDamages"
                           required
                           name="paidDamages"
                           id="paidDamages"
                           maxlength="100"
                           v-on:focus="paidDamages = paidDamages || ''"
                           v-on:blur="paidDamages = paidDamages || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="paidThirdPartyCosts" label="Paid Third Party Costs:" before-after="pound">
                    <input autocomplete="off" v-model.number="paidThirdPartyCosts"
                           required
                           name="paidThirdPartyCosts"
                           id="paidThirdPartyCosts"
                           maxlength="100"
                           v-on:focus="paidThirdPartyCosts = paidThirdPartyCosts || ''"
                           v-on:blur="paidThirdPartyCosts = paidThirdPartyCosts || 0"
                           v-two-dp
                           type="number">
                </control>
            </div>

            <div class="flex-grid__item flex-grid--space-left">
                <control for="paidDefenceCosts" label="Paid Defence Costs:" before-after="pound">
                    <input autocomplete="off" v-model.number="paidDefenceCosts"
                           required
                           name="paidDefenceCosts"
                           id="paidDefenceCosts"
                           maxlength="100"
                           v-on:focus="paidDefenceCosts = paidDefenceCosts || ''"
                           v-on:blur="paidDefenceCosts = paidDefenceCosts || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="recoveredCosts" label="Recovered Costs:" before-after="pound">
                    <input autocomplete="off" v-model.number="recoveredCosts"
                           required
                           name="recoveredCosts"
                           id="recoveredCosts"
                           maxlength="100"
                           v-on:focus="recoveredCosts = recoveredCosts || ''"
                           v-on:blur="recoveredCosts = recoveredCosts || 0"
                           v-two-dp
                           type="number">
                </control>
                <control for="totalInitialReserve" label="Total Reserve:" before-after="pound">
                    <input autocomplete="off" :value="totalReserve || 0"
                           readonly
                           v-two-dp
                           disabled>
                </control>
                <control for="netPaid" label="Net Paid:" before-after="pound">
                    <input autocomplete="off" :value="netPaid || 0"
                           disabled
                           v-two-dp
                           type="number">
                </control>
                <control for="totalPaid" label="Total Paid:" before-after="pound">
                    <input autocomplete="off" :value="totalPaid || 0"
                           required
                           v-two-dp
                           disabled
                           type="number">
                </control>
                <control for="netPaid" label="Net Paid:" before-after="pound">
                    <input autocomplete="off" v-model.number="netPaid"
                           required
                           name="netPaid"
                           id="netPaid"
                           maxlength="100"
                           v-two-dp
                           disabled
                           type="number">
                </control>
                <div class="flex-grid flex-grid--reduced-bottom-margin">
                    <div class="flex-grid__g-2 flex-grid--input-label">

                    </div>
                    <div class="flex-grid__g-7">
                        <button @click="save()" class="a-button a-button--loader-button"
                                :class="[isSaving ?'a-loader--white':'']">
                            <span :class="[isSaving ? 'a-button--span-hidden' : '']">Save</span></button>
                        <button v-if="showBackBtn" @click="close('showAllSummary')"
                                class="a-button a-button--no-margin">{{ this.modal ? 'Close' : 'Back'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateInput from 'components/form/control/DateInput.vue';
    import Control from 'components/form/Control.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import currencyFormat from "mixins/currencyFormat";

    export default {
        name: 'initial-reserves-costs',
        props: {
            claim: {
                type: Object,
                required: true
            },
            modal: {
                type: Boolean,
                default: false
            },
            isSaving: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "Reserves & Costs (editing)"
            },
            showBackBtn: {
                type: Boolean,
                default: true
            }
        },
        components: {
            Control,
            DateInput
        },
        mixins: [
            currencyFormat
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        data() {
            const getValue = costKey => this.claim.cost ? this.claim.cost[costKey] || 0 : 0;
            return {
                damagesReserve: getValue('current_damages_reserve'),
                thirdPartyReserve: getValue('current_third_party_reserve'),
                defenceCostsReserve: getValue('current_defence_costs_reserve'),
                paidDamages: getValue('paid_damages'),
                paidThirdPartyCosts: getValue('paid_third_party_costs'),
                paidDefenceCosts: getValue('paid_defence_costs'),
                recoveredCosts: getValue('recovered_costs'),
            }
        },
        computed: {
            totalReserve() {
                return parseFloat(this.damagesReserve) + parseFloat(this.thirdPartyReserve) + parseFloat(this.defenceCostsReserve);
            },
            totalPaid() {
                return parseFloat(this.paidDamages) + parseFloat(this.paidThirdPartyCosts) + parseFloat(this.paidDefenceCosts);
            },
            netPaid() {
                return parseFloat(this.totalPaid) - parseFloat(this.recoveredCosts);
            },
        },
        methods: {
            close(value) {
                this.$emit('close', value);
            },
            save() {
                this.$emit('save', {
                    claim_id: this.claim.id,
                    currentDamagesReserve: this.damagesReserve,
                    currentThirdPartyReserve: this.thirdPartyReserve,
                    currentDefenceCostsReserve: this.defenceCostsReserve,
                    paidDamages: this.paidDamages,
                    paidThirdPartyCosts: this.paidThirdPartyCosts,
                    paidDefenceCosts: this.paidDefenceCosts,
                    recoveredCosts: this.recoveredCosts,
                });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// InitialReservesCosts.vue?63f43893